import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { Form, Input, Button } from "antd";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { confirmForgotPassword, forgotPassword } from "./cognito";
import { Box, Card, Stack, Typography } from "@mui/material";
import MainInput from "../forms/main_input";
import { MainButton, SuccessButton } from "..";
import { Constants } from "../../utils/constants";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 24, color: "white" }} spin />
);

const antIconResending = <LoadingOutlined style={{ fontSize: 16 }} spin />;

function ForgotPassword({ authStore }) {
  const [submitting, setSubmitting] = useState(false);
  const [resending, setResending] = useState(false);
  const [error, setError] = useState("");
  const [passwordStep, setPasswordStep] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");

  const [userName, setUserName] = useState("");
  const [userNameError, setUserNameError] = useState(false);
  const [code, setCode] = useState("");
  const navigate = useNavigate();

  const onFinish = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    setUserNameError(false);
    if (!passwordStep) {
      try {
        if (!userName) {
          setUserNameError(true);
          setSubmitting(false);
          setError("Email is required");
          return;
        }
        await forgotPassword(userName);
        setPasswordStep(true);
      } catch (e) {
        setError(e.message);
      }
    } else {
      if (!code) {
        setError("Code is required");
        setSubmitting(false);
        return;
      }
      if (newPassword !== newPassword2) {
        setError("Password mismatch");
        setSubmitting(false);
        return;
      }
      try {
        await confirmForgotPassword(userName, code, newPassword);
        navigate("/login");
      } catch (e) {
        setError(e.message);
      }
    }
    setSubmitting(false);
  };

  const resendCode = async () => {
    setResending(true);
    await forgotPassword(userName);
    setResending(false);
  };

  return (
    <Box
      sx={{
        padding: "auto",
        display: "flex",
        alignItems: "start",
        justifyContent: "center",
        pt: "3rem",
      }}
    >
      <Card
        sx={{
          padding: "3rem 2.5rem",
        }}
      >
        <Box
          component={"form"}
          noValidate
          onSubmit={onFinish}
          sx={{
            minWidth: { xs: 300, sm: 360, },
            maxWidth: 500,
          }}
        >
          {!passwordStep && (
            <MainInput
              label="Email"
              name="username"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              required={true}
              error={userNameError}
            />
          )}

          {passwordStep && (
            <Box>
              <Typography sx={{
                fontSize: Constants.Styles.fontSize.lg,
                fontWeight: Constants.Styles.fontWeight.medium,
                lineHeight: Constants.Styles.lineHeight.lg,
              }}>Set new password</Typography>
              <Stack
                spacing={2}
                mt={2}
              >
                <MainInput
                  label="Code"
                  name="code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />

                <MainInput
                  name="newPassword"
                  label="New Password"
                  text="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  isSecure={true}
                />
                <MainInput
                  name="newPassword1"
                  label="Re-enter Password"
                  text="password"
                  value={newPassword2}
                  onChange={(e) => setNewPassword2(e.target.value)}
                  isSecure={true}
                />

              </Stack>
            </Box>
          )}
          {error && <Typography sx={{
            fontSize: Constants.Styles.fontSize.sm,
            color: Constants.Colors.light.destructive,
            mt: 2,
          }}>{error}</Typography>}

          <Box
            sx={{
              mt: 3,
            }}
          >
            <SuccessButton
              text={passwordStep ? "Set Password" : "Send one time reset code"}
              isSubmitting={submitting}
              type="submit"
              size="medium"
            />
          </Box>
          {passwordStep && <Box
            sx={{
              mt: 2,
            }}
          >
            <MainButton
              text={"Resend one-time reset code"}
              isSubmitting={resending}
              type="button"
              size="small"
              onClick={() => resendCode()}
            />
          </Box>}
        </Box>
      </Card>
    </Box>
  );
}

export default observer(ForgotPassword);
